import type { IconSvgObject } from './types';

const DropdownFieldTypeIcon: IconSvgObject = [
  ["path", { d: "M20 4H4C2.89543 4 2 4.89543 2 6V10C2 11.1046 2.89543 12 4 12H20C21.1046 12 22 11.1046 22 10V6C22 4.89543 21.1046 4 20 4Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 7L16 9L18 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 16H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 20H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default DropdownFieldTypeIcon;
